import http from '../../../common/utils/http'
import apiUtils from '../../../common/utils/apiUtils'
import { API_BASE_URL } from '../../../common/utils/commonUrl'

export default {
  getCommodityPageList: data => {
    return http
      .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getCommodityPageList`, {
        params: data
      })
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  },
  getMemberPointsChangeLogPageList: data => {
    return http
      .get(
        `${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getMemberPointsChangeLogPageList`,
        { params: data }
      )
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  },
  getRankEquityList: data => {
    return http
      .get(
        `${API_BASE_URL}/api/wxoa/pmall/WxoaPmall/getMemberLevelRulePageList`,
        { params: data }
      )
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  },
  getExchangeRecord: data => {
    return http
      .get(
        `${API_BASE_URL}/api/wxoa/pmall/WxoaPmall/getPointsRedeemOrderList`,
        { params: data }
      )
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  },
  getProductDetails: data => {
    return http
      .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getCommodityDetails`, {
        params: data
      })
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  },
  purchaseProduct: data => {
    return http
      .post(
        `${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/createPointsRedeemOrder`,
        data
      )
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  productSearchInfo: data => {
    return http
      .get(
        `${API_BASE_URL}/api/wxoa/pmall/WxoaPmall/getMemberCommoditySearchRecords`,
        { params: data }
      )
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  },
  getShooptingCardNum: data => {
    return http
      .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getShoppingCartQty`, {
        params: data
      })
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  addShoppingCartById: data => {
    return http
      .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/addShoppingCart`, {
        params: data
      })
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  submitOrder: data => {
    return http
      .post(
        `${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/submitPointsRedeemOrder`,
        data
      )
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  getShoppingCartList: data => {
    return http
      .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getShoppingCartList`, {
        params: data
      })
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  },
  deleteCommodityById: data => {
    return http
      .post(
        `${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/administrateShoppingCart`,
        data
      )
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  purchaseOrder: data => {
    return http
      .post(
        `${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/payPointsRedeemOrder`,
        data
      )
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  getPayStatus: data => {
    return http
      .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getPayStatus`, {
        params: data
      })
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  getMemberConsumption: data => {
    // api/wxoa/member/member/getConsumptionLogByMemberId
    return http
      .get(
        `${API_BASE_URL}/api/wxoa/member/member/getMemberReservationInfoList2`,
        { params: data }
      )
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  },
  getMemberOrder: data => {
    return http
      .get(
        `${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getPointsRedeemOrderPageList`,
        { params: data }
      )
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  },
  deleteOrderById: data => {
    return http
      .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/deletePointsRedeemOrder`, {
        params: data
      })
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  closeOrderById: data => {
    return http
      .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/closePointsRedeemOrder`, {
        params: data
      })
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  getMyExtendedInsurance: data => {
    return http
      .get(
        `${API_BASE_URL}/api/wxoa/member/member/getExtensionInfoByMemberId`,
        { params: data }
      )
      .then(
        function (result) {
          return apiUtils.getDataFormCodeResponse(result)
        }
      )
  },
  getMemberStoredValue: data => {
    return http
      .get(
        `${API_BASE_URL}/api/wxoa/member/member/getStoredValueCardChangeRecordByMemberId`,
        { params: data }
      )
      .then(
        function (result) {
          return apiUtils.getDataFormResponse(result)
        }
      )
  }
}



// WEBPACK FOOTER //
// ./src/api/wx-member/points-mall/points-mall.js